export const JSON_ONE21NW = {
  req_user_id: "AzamT469",
  me_id: "202402140004",
  amount: "100",
  customer_email: "shahkaidea@safexpay.com",
  mobile_no: "9876543210",
  expiry_date: "2024-11-12",
  media_type: ["EMAIL", "WHATS_APP", "SMS"],
  order_id: "1231T",
  first_name: "Azam",
  last_name: "Shah",
  reminder1: "",
  product: "product12321",
  dial_code: "+91",
  reminder2: "",
  failure_url: "",
  success_url: "",
  country: "ARE",
  currency: "AED",
};
